import React, { useEffect, useState } from 'react'
import { Collapse as AntCollapse, ConfigProvider, Flex } from 'antd'
import { ReactComponent as CheckMarkGray } from '../../assets/questionnaire/Check-gray.svg'
import { ReactComponent as CheckMark } from '../../assets/questionnaire/Check.svg'
import { ReactComponent as ArrowUp } from '../../assets/questionnaire/arrow-square-up.svg'
import { ReactComponent as ArrowDown } from '../../assets/questionnaire/arrow-square-down.svg'
import { useDomainsContext } from '../../contexts/DomainsContext'


const items = ({ title, dimensions, id, indexCount, currentDimension, doneDimensionIds }, collapsed) => [
  {
    key: id,
    label: <Flex align='center' gap={17} style={{  }}>
      <Flex justify='center' align='center' style={{ width: collapsed ? 36 : '50px', height: collapsed ? 36 : '50px', borderRadius: '50%', backgroundColor: '#18CAD8', fontSize: collapsed ? 14.4 : 20, fontWeight: 700, color: '#FFF' }}>{indexCount+1}</Flex>
      <Flex align='center' justify='space-between' style={{ width: '100%' }}>
        <div style={{ fontSize: 14, color: '#07224D' }}>{title}</div>
        {collapsed ? <ArrowUp/> : <ArrowDown/>}
      </Flex>
    </Flex>,

    children: <Flex vertical={true} gap={15}>
      {dimensions.map(({ title, id: dimensionId }) => {
        return <Flex align='center' gap={10}>
          {doneDimensionIds.includes(dimensionId) ? <CheckMark/> : <CheckMarkGray/>}
          <div style={{ fontSize: 12, color: currentDimension.dimensionId === dimensionId ? '#18CAD8' : '#07224D' }}>{title}</div>
        </Flex>
      })}
    </Flex>,
  },
];

const Collapse = ({ domainData, indexCount }) => {

  const { currentDimension, currentDomain, doneDimensionIds } = useDomainsContext()

  const { title, dimensions, id } = domainData
  
  const [collapsed, setCollapsed] = useState(currentDomain.domainId === id)
  const [activeKey, setActiveKey] = useState(currentDomain.domainId)

  const onChange = (key) => {
    // console.log(key);
    setCollapsed(prev => !prev)
    setActiveKey(id)
  };

  useEffect(() => {
    setCollapsed(currentDomain.domainId === id)
    setActiveKey(currentDomain.domainId)
  }, [currentDomain, currentDimension])

  return (
    <>
      <ConfigProvider theme={{
        "components": {
          "Collapse": {
            "contentBg": "rgb(240, 254, 255)",
            "headerBg": "rgb(240, 254, 255)",
            "colorBorder": "rgb(24, 202, 216)",
            "borderRadiusLG": 15,
            // "lineWidth": 1,
            "headerPadding": "10px",
            contentPadding: '10px'
          }
        }
      }}>
        <AntCollapse items={items({ title, dimensions, id, indexCount, currentDimension, doneDimensionIds }, collapsed)} activeKey={collapsed && activeKey} onChange={onChange} expandIconPosition='end' expandIcon={(panelProps) => {
          // console.log(panelProps)
          return null
        }}
          bordered={collapsed}
        />
      </ConfigProvider>
    </>
  )
}

export default Collapse